// extracted by mini-css-extract-plugin
export default {"circle":"CircleLabel__circle___w15oe"};